import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3adc3982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body py-4" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-4 fixHeightScroll" }
const _hoisted_6 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Collection of Minimum KYC Information ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 mb-5" }
const _hoisted_12 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_13 = { class: "col-lg-6 mb-5" }
const _hoisted_14 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_15 = { class: "col-lg-6 mb-5" }
const _hoisted_16 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_17 = { class: "col-lg-6 mb-5" }
const _hoisted_18 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_19 = { class: "col-lg-12 mb-5" }
const _hoisted_20 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_21 = { class: "col-6 mb-5" }
const _hoisted_22 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_23 = { class: "col-6 mb-5" }
const _hoisted_24 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_25 = { class: "col-6 mb-5" }
const _hoisted_26 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_27 = { class: "col-6 mb-5" }
const _hoisted_28 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_29 = { class: "form-label fs-6 fw-bold text-dark required mt-7" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = {
  class: "form-label fs-6 fw-bold text-dark",
  style: {"width":"130px"}
}
const _hoisted_33 = {
  class: "w-100 my-5 card verify-card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "pb-3" }
const _hoisted_36 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_38 = { class: "questionTitle mb-7" }
const _hoisted_39 = {
  key: 0,
  class: "questionTitle mb-7",
  style: {"border":"1px solid gray","padding":"3px"}
}
const _hoisted_40 = {
  key: 1,
  class: "questionTitle mb-7",
  style: {"border":"1px solid gray","padding":"3px"}
}
const _hoisted_41 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " For Sole Trader Only ")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-lg-6 mb-5" }
const _hoisted_47 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_48 = { class: "col-lg-6 mb-5" }
const _hoisted_49 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_50 = { class: "col-lg-12 mb-5" }
const _hoisted_51 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_52 = { class: "col-lg-6 mb-5" }
const _hoisted_53 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_54 = { class: "col-lg-6 mb-5" }
const _hoisted_55 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_56 = { class: "col-lg-6 mb-5" }
const _hoisted_57 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_58 = { class: "col-lg-6 mb-5" }
const _hoisted_59 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_60 = { class: "col-lg-12 mb-5" }
const _hoisted_61 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_62 = { class: "col-lg-12 mb-5" }
const _hoisted_63 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_64 = { class: "col-lg-12 mb-5" }
const _hoisted_65 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_66 = { class: "col-lg-12 mb-5" }
const _hoisted_67 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_68 = { class: "col-lg-12 mb-5" }
const _hoisted_69 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_70 = { class: "col-lg-12 mb-5" }
const _hoisted_71 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_72 = { class: "col-lg-12 mb-5" }
const _hoisted_73 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_74 = {
  class: "w-100 card my-5",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Verification ")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-6 mb-5" }
const _hoisted_80 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_81 = { class: "col-lg-6 mb-5" }
const _hoisted_82 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_83 = { class: "col-lg-6 mb-5" }
const _hoisted_84 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_85 = { class: "col-lg-6 mb-5" }
const _hoisted_86 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_87 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_88 = { class: "card-body" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Admin Use Only ")
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-lg-6 mb-5" }
const _hoisted_93 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_94 = { class: "col-lg-6 mb-5" }
const _hoisted_95 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_96 = { class: "col-lg-6 mb-5" }
const _hoisted_97 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_98 = { class: "col-lg-6 mb-5" }
const _hoisted_99 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_100 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center fs-4 pt-3" }, [
  /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "You may save the KYC form and submit it later.")
], -1))
const _hoisted_102 = { class: "card-body d-flex justify-content-center" }
const _hoisted_103 = { class: "col-8 fixHeightScroll" }
const _hoisted_104 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_105 = { class: "card-body" }

import { useI18n } from "vue-i18n";
import { Field } from "vee-validate";
import { ref, onMounted, computed } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import previewAuKycForm from "./PreviewAuKycForm.vue";
import SignatureModal from "./SignatureModal.vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import financialTest from "@/core/data/verification/auFinancialQuestions";
import { getAuRegionCodes } from "@/core/data/phonesData";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAuKycForm',
  props: {
    selectedPartyId: {}
  },
  emits: ["fetchData", "returnTable"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const signatureModalRef = ref<InstanceType<typeof SignatureModal>>();
const regionCodes = ref<any>(getAuRegionCodes());
console.log("regionCodes", regionCodes.value);
const { t } = useI18n();

const isLoading = ref(true);
const kycInfos = ref({} as any);
const predefinedIndustryValues = [
  "government",
  "accounting",
  "banking",
  "finance",
  "insurance",
  "other",
];
const predefinedOccupationValues = [
  "director",
  "manager",
  "entry_level",
  "other",
];
const shouldShowIndustrySelect = computed(
  () =>
    !kycInfos.value.industry ||
    predefinedIndustryValues.includes(kycInfos.value.industry)
);
const shouldShowOccupationSelect = computed(
  () =>
    !kycInfos.value.occupation ||
    predefinedOccupationValues.includes(kycInfos.value.occupation)
);
const updateOccupationFromOtherPosition = () => {
  const otherPosition = kycInfos.value.financialInfo?.otherPosition?.trim();

  if (kycInfos.value.occupation === "other" && otherPosition) {
    kycInfos.value.occupation = otherPosition;
  }
};

const show_exp1_more = ref(false);
const trading_exp = computed(() => ({
  exp2: {
    id: "exp2",
    text: t("tip.verificationFinancialHaveBankruptcy"),
    show_more: false,
    more_question: t("tip.verificationFinancialIndicateDischarge"),
  },
  exp3: {
    id: "exp3",
    text: t("tip.verificationFinancialAnyPersonOfCommodityOrRegulatory"),
    show_more: false,
    more_question: t("tip.verificationFinancialProvideExchangeOrAgency"),
  },
  exp4: {
    id: "exp4",
    text: t("tip.verificationFinancialAreYouPep"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
  exp5: {
    id: "exp5",
    text: t("tip.verificationFinancialAreYouAssociate"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
}));

const loadUserKycInfo = async () => {
  isLoading.value = true;
  try {
    kycInfos.value = await UserService.getNewAuKycInfos(props.selectedPartyId);
    kycInfos.value.residence =
      kycInfos.value.residence || kycInfos.value.personalInfo.residence;
    updateOccupationFromOtherPosition();
    console.log("------ kycInfos.value -------");
    console.log(kycInfos.value);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const openSignaturePanel = () => {
  signatureModalRef.value?.show();
};

const handelSignature = (_signature) => {
  kycInfos.value.staffSignature = _signature;
  signatureModalRef.value?.hide();
  signatureModalRef.value?.clear();
};

const returnTable = () => {
  emits("returnTable");
};

const submitKycForm = async (_op: string) => {
  isLoading.value = true;
  try {
    if (_op == "update") {
      await UserService.putSocialMediaInfoBatch(
        props.selectedPartyId,
        kycInfos.value.socialMediaTypes
      );
      await UserService.putKycForm(props.selectedPartyId, kycInfos.value);
      MsgPrompt.success(t("tip.updateSuccess")).then(() => {
        emits("fetchData", 1);
      });
    } else {
      await UserService.putSocialMediaInfoBatch(
        props.selectedPartyId,
        kycInfos.value.socialMediaTypes
      );
      await UserService.putKycForm(props.selectedPartyId, kycInfos.value);
      await UserService.signKycForm(props.selectedPartyId, kycInfos.value);
      MsgPrompt.success(t("tip.submitSuccess")).then(() => {
        emits("fetchData", 1);
      });
    }
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  loadUserKycInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "d-flex justify-content-end" }, [
      _createElementVNode("button", {
        class: "btn btn-light btn-success btn-md me-3",
        onClick: returnTable,
        style: {"margin-top":"-65px","height":"45px"}
      }, " Return ")
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createVNode(_component_LoadingRing)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("fields.firstName")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.firstName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "firstName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.firstName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                              name: "firstName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("fields.lastName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.lastName,
                          tabindex: "2",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "lastName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.lastName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((kycInfos.value.lastName) = $event)),
                              name: "lastName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("fields.priorName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.priorName,
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "priorName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.priorName,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kycInfos.value.priorName) = $event)),
                              name: "priorName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.birthdate")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.birthday,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "birthday",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.birthday,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.address")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.address,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((kycInfos.value.address) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "address",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.address,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((kycInfos.value.address) = $event)),
                              name: "address",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("fields.industry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.industry,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((kycInfos.value.industry) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "industry"
                        }, {
                          default: _withCtx(() => [
                            (shouldShowIndustrySelect.value)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: kycInfos.value.industry,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((kycInfos.value.industry) = $event)),
                                  name: "industry",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "government",
                                      label: _ctx.$t('fields.government')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "accounting",
                                      label: _ctx.$t('fields.accounting')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "banking",
                                      label: _ctx.$t('fields.banking')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "finance",
                                      label: _ctx.$t('fields.finance')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "insurance",
                                      label: _ctx.$t('fields.insurance')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "other",
                                      label: _ctx.$t('fields.other')
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_el_input, {
                                  key: 1,
                                  modelValue: kycInfos.value.industry,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((kycInfos.value.industry) = $event)),
                                  name: "industry",
                                  size: "large"
                                }, null, 8, ["modelValue"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("fields.position")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.occupation,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "position"
                        }, {
                          default: _withCtx(() => [
                            (shouldShowOccupationSelect.value)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: kycInfos.value.occupation,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                                  name: "position",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "director",
                                      label: _ctx.$t('fields.director')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "manager",
                                      label: _ctx.$t('fields.manager')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "entry_level",
                                      label: _ctx.$t('fields.entryLevel')
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "other",
                                      label: _ctx.$t('fields.other')
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_el_input, {
                                  key: 1,
                                  modelValue: kycInfos.value.occupation,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                                  name: "position",
                                  size: "large"
                                }, null, 8, ["modelValue"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("fields.residence")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.residence,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((kycInfos.value.residence) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "position"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.residence,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((kycInfos.value.residence) = $event)),
                              placeholder: _ctx.$t('tip.selectCountry'),
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("fields.nationality")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.citizen,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((kycInfos.value.citizen) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "position"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.citizen,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((kycInfos.value.citizen) = $event)),
                              placeholder: _ctx.$t('fields.nationality'),
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("title.socialMedia")), 1),
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycInfos.value.socialMediaTypes, (type, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12 mb-3",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("fields." + type.name)), 1),
                            _createVNode(_component_el_input, {
                              modelValue: type.account,
                              "onUpdate:modelValue": ($event: any) => ((type.account) = $event),
                              tabindex: "2",
                              type: "text",
                              name: type.name,
                              autocomplete: "off",
                              size: "large"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t("title.tradingBackground")), 1)
                    ]),
                    _hoisted_37,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financialTest)['en-us'], (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12 mb-3",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_38, " ( " + _toDisplayString(index) + " ) " + _toDisplayString(item.question), 1),
                        (index != '10')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(financialTest)["en-us"][index].options[
                      kycInfos.value.financialInfo["q" + index]
                    ]), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycInfos.value.financialInfo[
                      'q' + index
                    ], (_option, _index) => {
                                return (_openBlock(), _createElementBlock("div", { key: _index }, _toDisplayString(_unref(financialTest)["en-us"][index].options[_option]), 1))
                              }), 128))
                            ]))
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("fields.businessName")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessName,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((kycInfos.value.businessName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessName,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((kycInfos.value.businessName) = $event)),
                              name: "businessName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("fields.businessNumber")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.businessNumber,
                          tabindex: "2",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessNumber,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((kycInfos.value.businessNumber) = $event)),
                              name: "businessNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("fields.businessAddress")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.businessAddress,
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessAddress",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessAddress,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((kycInfos.value.businessAddress) = $event)),
                              name: "businessAddress",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("fields.businessCity")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCity,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((kycInfos.value.businessCity) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCity",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCity,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((kycInfos.value.businessCity) = $event)),
                              name: "businessCity",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("fields.businessState")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessState,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((kycInfos.value.businessState) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessState",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessState,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((kycInfos.value.businessState) = $event)),
                              name: "businessState",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("fields.businessZipCode")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessZipCode,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((kycInfos.value.businessZipCode) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessZipCode",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessZipCode,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((kycInfos.value.businessZipCode) = $event)),
                              name: "businessZipCode",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("fields.businessCountry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCountry,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((kycInfos.value.businessCountry) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCountry",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCountry,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((kycInfos.value.businessCountry) = $event)),
                              name: "businessCountry",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("fields.businessCompanyPurposeBetweenUs")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCompanyPurposeBetweenUs,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((kycInfos.value.businessCompanyPurposeBetweenUs) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCompanyPurposeBetweenUs",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCompanyPurposeBetweenUs,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((kycInfos.value.businessCompanyPurposeBetweenUs) = $event)),
                              name: "businessCompanyPurposeBetweenUs",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t("fields.businessServiceRequireReason")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessServiceRequireReason,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((kycInfos.value.businessServiceRequireReason) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessServiceRequireReason",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessServiceRequireReason,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((kycInfos.value.businessServiceRequireReason) = $event)),
                              name: "businessServiceRequireReason",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("fields.businessIndustry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessIndustry,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((kycInfos.value.businessIndustry) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessIndustry",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessIndustry,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((kycInfos.value.businessIndustry) = $event)),
                              name: "businessIndustry",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("fields.businessClientIndustry1")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry1,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((kycInfos.value.businessClientIndustry1) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry1",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry1,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((kycInfos.value.businessClientIndustry1) = $event)),
                              name: "businessClientIndustry1",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t("fields.businessClientIndustry2")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry2,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((kycInfos.value.businessClientIndustry2) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry2",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry2,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((kycInfos.value.businessClientIndustry2) = $event)),
                              name: "businessClientIndustry2",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("fields.businessClientIndustry3")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry3,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((kycInfos.value.businessClientIndustry3) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry3",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry3,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((kycInfos.value.businessClientIndustry3) = $event)),
                              name: "businessClientIndustry3",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("fields.businessService")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessService,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((kycInfos.value.businessService) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessService",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessService,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((kycInfos.value.businessService) = $event)),
                              name: "businessService",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _hoisted_77,
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("fields.formId")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idType,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((kycInfos.value.idType) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "idType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.idType,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((kycInfos.value.idType) = $event)),
                              name: "idType",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: 1,
                                  label: "Government ID"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 2,
                                  label: "Driver's License"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 3,
                                  label: "Passport"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("fields.doc_number")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idNumber,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.idNumber,
                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("fields.issue_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idIssuedOn,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idIssuedOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idIssuedOn,
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t("fields.expire_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idExpireOn,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idExpireOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idExpireOn,
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _hoisted_90,
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t("fields.adminStaffMember")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffName,
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((kycInfos.value.staffName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.staffName,
                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((kycInfos.value.staffName) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("fields.adminStaffPosition")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffPosition,
                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((kycInfos.value.staffPosition) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffPosition",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.staffPosition,
                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((kycInfos.value.staffPosition) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t("fields.signDate")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffSignedOn,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((kycInfos.value.staffSignedOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffSignedOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.staffSignedOn,
                              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((kycInfos.value.staffSignedOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t("action.sign")), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            class: "btn btn-light btn-success btn-sm me-3",
                            style: {"width":"100%","height":"40px"},
                            onClick: openSignaturePanel
                          }, _toDisplayString(_ctx.$t("action.sign")), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("button", {
                      class: "btn btn-light btn-primary btn-lg me-3",
                      onClick: _cache[58] || (_cache[58] = ($event: any) => (submitKycForm('update')))
                    }, _toDisplayString(_ctx.$t("action.save")), 1),
                    _createElementVNode("button", {
                      class: "btn btn-light btn-warning btn-lg me-3",
                      onClick: _cache[59] || (_cache[59] = ($event: any) => (submitKycForm('submit')))
                    }, _toDisplayString(_ctx.$t("action.submit")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createVNode(previewAuKycForm, {
                      kycInfos: kycInfos.value,
                      regionCodes: regionCodes.value
                    }, null, 8, ["kycInfos", "regionCodes"])
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _createVNode(SignatureModal, {
      ref_key: "signatureModalRef",
      ref: signatureModalRef,
      onHandelSignature: handelSignature
    }, null, 512)
  ], 64))
}
}

})